import { HTTP } from '@util/http-p'

class OrderModel extends HTTP {
    get_list(data) {
        return this.request({
            url: 'apihome/order/get_spec_list',
            data: data
        })
    }

    get_order_list(data) {
        return this.request({
            url: 'apihome/order/get_order_list',
            data: data
        })
    }
    get_childorder_list() {
        return this.request({
            url: 'apiadmin/order/get_childorder_list',
            data: data
        })
    }
    orderSubmit(data) {
        return this.request({
            url: 'apihome/order/orderCreate',
            data: data,
            method: "POST"
        })
    }

    orderUpdate(data) {
        return this.request({
            url: 'apihome/order/orderUpdate',
            data: data,
            method: "POST"
        })
    }

    getOrderData(data) {
        return this.request({
            url: 'apihome/order/getOrderData',
            data: data
        })
    }

    getOrderData2(data) {
        return this.request({
            url: 'apiadmin/order/getOrderData',
            data: data
        })
    }

    getDetail(data) {
        return this.request({
            url: 'apihome/order/get_detail',
            data: data
        })
    }

    getDataStat(data) {
        return this.request({
            url: 'apiadmin/order/get_data_stat',
            data: data
        })
    }
    getPrintOrderData(data) {
        return this.request({
            url: 'apiadmin/order/get_total_summary',
            data: data
        })
    }

    getTotalSummary(data) {
        return this.request({
            url: 'apiadmin/order/get_total_summary',
            data: data
        })
    }
    checkAddOrderTime(data={}) {
        return this.request({
            url: 'apihome/order/checkAddOrderTime',
            data: data
        })
    }
    getAdminSummary(data) {
        return this.request({
            url: 'apiadmin/order/get_summary',
            data: data
        })
    }

    getPrintSummary(data) {
        return this.request({
            url: 'apiadmin/order/get_print_summary',
            data: data
        })
    }

    getHomeSummary(data) {
        return this.request({
            url: 'apihome/order/get_summary',
            data: data
        })
    }

    getHomeDataStat(data) {
        return this.request({
            url: 'apihome/order/get_data_stat',
            data: data
        })
    }

    cancelOrder(data) {
        return this.request({
            url: 'apihome/order/cancelOrder',
            data: data,
            method: "POST"
        })
    }

    changeStatus(data) {
        return this.request({
            url: 'apiadmin/order/changeStatus',
            data: data,
            method: "POST"
        })
    }

    setRemark(data) {
        return this.request({
            url: 'apihome/order/setRemark',
            data: data,
            method: "POST"
        })
    }
}

export { OrderModel }